module.exports = __webpack_public_path__ + "static/media/bdo-report.cba5b671.jpg";